import {
  mdiCalendarMultiselect,
  mdiHeartOutline,
  mdiHeart,
  mdiShareVariant,
  mdiStar,
  mdiChevronLeft,
  mdiChevronRight,
  mdiCircleSlice8,
  mdiCloseCircle,
  mdiFacebook,
  mdiTwitter,
  mdiXing,
  mdiLinkedin,
  mdiWhatsapp,
  mdiOpenInNew,
  mdiMapMarker,
  mdiMapClock,
  mdiClock,
  mdiPlus,
  mdiPlusCircle,
  mdiMinusCircle,
  mdiWeb,
  mdiEmail,
  mdiPhone,
  mdiCellphone
} from "@mdi/js";
import moment from "moment";
import Vue from "vue";
import VueI18n from "vue-i18n";
import VTooltip from "v-tooltip";
import "@/styles/v-tooltip.scss";
import createLang from "@/detail-view_lang";
import findConfig from "@/lib/find-config";
import humanFileSize from "@/lib/human-file-size";
import getFileTypeIcon from "@/lib/get-file-type-icon";
import findEvents from "@/lib/find-events";
import findMomentsForEventId from "@/lib/find-moments-for-event-id";
import niceDate from "@/lib/nice-date";
import findFeatures from "@/lib/find-features";
import createICal from "@/lib/create-ical";
import findLdJson from "@/lib/find-ld-json";
import fixLink from "@/lib/fix-link";
import EoDetailMap from "@/components/DetailMap/DetailMap.vue";
import EoChipGroup from "@/components/ChipGroup.vue";
import EventPicture from "@/components/EventPicture/EventPicture.vue";
import EventPictureSlider from "@/components/EventPictureSlider/EventPictureSlider.vue";
import getGoogleRouteLinkForAddress from "@/lib/get-google-route-link-for-address";
import ColorsMixin from "@/mixins/ColorsMixin";
import VueHeadful from "vue-headful";
import { getShortTitle, getTitle } from "@/lib/get-short-title";
import "@/styles/DetailView.sass";
import { DateTime } from "luxon";
import {
  appendCurrentParamsToURL,
  replaceWithWebContent
} from "@/helpers/commonHelper";

Vue.use(VTooltip);

// language stuff
Vue.use(VueI18n);
const i18n = createLang();

function getToday() {
  // not UTC offset correction here, since we only use it in calendar view
  return moment().format("YYYY-MM-DD");
}

export default {
  name: "detail-view",
  components: {
    EventPictureSlider,
    EventPicture,
    EoChipGroup,
    EoDetailMap,
    VueHeadful
  },
  mixins: [ColorsMixin],
  props: {
    id: {
      type: String,
      default: "eoev-detail-view"
    },
    eventId: String,
    momentId: String,
    initialData: [], // might be string or array
    initialSettings: Object,
    initialCategories: undefined,
    initialFeatures: undefined,
    apiKey: String,
    showNotepad: Boolean
  },
  data: () => ({
    copyright: "",
    isLoading: true,
    event: undefined, // event to show
    settings: {}, // loaded settings
    featureList: [], // loaded features
    error: "",
    widgetWidth: 0, // width of element
    calendarValue: getToday(), // needed to navigate calendar
    showLess: true,
    loadingMoments: true,
    firstClickOnCalendarPanel: true,
    socialShareDialog: false,
    ldJson: undefined,
    mobileMap: false,
    refreshMapValue: 0,
    readMore: false,
    onlyMobile: false,
    loadedMoments: [],
    openPanel: null,
    isEmailOpen: false,
    isCellphoneOpen: false,
    isPhoneOpen: false,
    operatorAddressArr: [],
    discountInformation: "",
    // icons
    mdiCalendarMultiselect: mdiCalendarMultiselect,
    mdiHeartOutline: mdiHeartOutline,
    mdiHeart: mdiHeart,
    mdiShareVariant: mdiShareVariant,
    mdiStar: mdiStar,
    mdiChevronLeft: mdiChevronLeft,
    mdiChevronRight: mdiChevronRight,
    mdiCircleSlice8: mdiCircleSlice8,
    mdiCloseCircle: mdiCloseCircle,
    mdiFacebook: mdiFacebook,
    mdiTwitter: mdiTwitter,
    mdiXing: mdiXing,
    mdiLinkedin: mdiLinkedin,
    mdiWhatsapp: mdiWhatsapp,
    mdiOpenInNew: mdiOpenInNew,
    mdiMapClock: mdiMapClock,
    mdiClock: mdiClock,
    mdiMapMarker: mdiMapMarker,
    mdiPlus: mdiPlus,
    mdiPlusCircle: mdiPlusCircle,
    mdiMinusCircle: mdiMinusCircle,
    mdiWeb: mdiWeb,
    mdiEmail: mdiEmail,
    mdiPhone: mdiPhone,
    mdiCellphone: mdiCellphone
  }),
  async created() {
    // load categories to Store

    if (this.initialCategories) {
      this.$store.commit("setCategories", this.initialCategories);
    } else {
      await this.$store.dispatch("loadCategories");
    }

    // if no settings => get config from API!
    if (this.initialSettings) {
      this.settings = this.initialSettings;
    } else {
      await this.loadSettings();
    }

    // data defined or get from API?
    if (this.initialData) {
      this.event =
        typeof this.initialData === "string"
          ? JSON.parse(this.initialData)
          : this.initialData;
      if (this.initialFeatures) {
        this.initialFeatures.forEach(feature => {
          if (
            !feature.internal_control_feature &&
            this.event.features.indexOf(feature._id) >= 0
          ) {
            this.featureList.push(
              feature.title +
                (this.event.featureValues &&
                this.event.featureValues[feature._id]
                  ? ": " + this.event.featureValues[feature._id]
                  : "")
            );
          }
        });
      }
    } else {
      await this.loadData();
      // load feature list
      if (this.event && this.event.features && this.event.features.length) {
        (await findFeatures(this.$store.state.apiUrl, this.cApiKey)).forEach(
          feature => {
            if (
              !feature.internal_control_feature &&
              this.event.features.indexOf(feature._id) >= 0
            ) {
              this.featureList.push(
                feature.title +
                  (this.event.featureValues &&
                  this.event.featureValues[feature._id]
                    ? ": " + this.event.featureValues[feature._id]
                    : "")
              );
            }
          }
        );
      }
    }

    // loading finished
    this.getDiscountInformation();
    this.isLoading = false;

    // load LD+JSON
    await this.loadLdJson();
  },
  mounted() {
    this.widgetWidth = this.$refs.theWidget?.offsetWidth;
  },
  computed: {
    hideBreadcrumb() {
      return !!this.settings.hideBreadcrumb;
    },
    currentMomentId() {
      return this.event && this.event.moment && this.event.moment._id;
    },
    title() {
      return getTitle(this.event);
    },
    shortTitle() {
      return getShortTitle(this.event);
    },
    isFavorite() {
      const id =
        this.event._id + (this.event.moment ? ":" + this.event.moment._id : "");

      return (
        this.$store.state.favorites &&
        this.$store.state.favorites.indexOf(id) > -1
      );
    },
    webPictures() {
      return (
        this.event?.pictures?.filter(p => {
          const entryHasWebChannel = this.event?.channels?.includes("web");
          const pictureHasWebChannel = p.channels?.includes("web");
          return !entryHasWebChannel || pictureHasWebChannel;
        }) || []
      );
    },
    webFiles() {
      return (
        this.event?.files?.filter(p => {
          const entryHasWebChannel = this.event?.channels?.includes("web");
          const fileHasWebChannel = p.channels?.includes("web");
          return !entryHasWebChannel || fileHasWebChannel;
        }) || []
      );
    },
    shortDescription() {
      if (this.event) {
        if (this.event.moment && this.event.moment.short_description)
          return this.event.moment.short_description;
        if (this.event.short_description) return this.event.short_description;
      }
      return "";
    },
    longDescription() {
      if (this.event) {
        if (this.event.moment && this.event.moment.description)
          return this.event.moment.description;
        // append feratel info fields if available
        // ignore if description already contains info
        let feratelSpecialInfo = this.event?.feratel_special_info;
        if (
          feratelSpecialInfo &&
          !this.event.description.includes(feratelSpecialInfo)
        ) {
          return this.event.description + "<br/>" + feratelSpecialInfo;
        }
        if (this.event.description) return this.event.description;
      }
      return "";
    },
    niceDate() {
      if (this.event && this.event.moment && this.event.moment.from) {
        return niceDate(this.event.moment.from, this.$i18n.locale);
      }
      return "";
    },
    niceTime() {
      if (this.event && this.event.moment && this.event.moment.from) {
        return niceDate(this.event.moment.from, this.$i18n.locale, true);
      }
      return "";
    },
    getEndTime() {
      if (this.event && this.event.moment && this.event.moment.to) {
        let startDate = DateTime.fromISO(this.event.moment.from);
        const endDate = DateTime.fromISO(this.event.moment.to);

        const dayDiff = endDate.diff(startDate, "days")?.toObject();
        if (dayDiff.days >= 1) {
          startDate = startDate.set({ day: endDate.day, month: endDate.month });
        }
        const diff = endDate.diff(startDate, ["hours", "minutes"])?.toObject();
        if (diff.hours && diff.minutes)
          return `${diff.hours} h ${diff.minutes} Min.`;
        else if (diff.hours && !diff.minutes) return `${diff.hours} h`;
        else if (!diff.hours && diff.minutes) return `${diff.minutes} Min.`;
      }
      return "";
    },
    address() {
      let address = "";

      if (this.event) {
        if (this.event.location?.title) {
          address = this.event.location.title;
        }

        if (this.event.location_text)
          address += (address ? " – " : "") + this.event.location_text;

        if (this.event.location && this.event.location.address) {
          const adr = this.event.location.address;

          if (adr.address) address += (address ? "<br />" : "") + adr.address;
          if (adr.additional_address)
            address += (address ? "<br />" : "") + adr.additional_address;
          if (
            this.settings.displayLocationCity &&
            (adr.zip || adr.city || adr.district)
          ) {
            let cityLine = adr.zip ? adr.zip : "";
            if (adr.city) cityLine += (cityLine ? "  " : "") + adr.city;
            if (adr.district && this.settings.displayLocationDistrict)
              cityLine += (cityLine ? " – " : "") + adr.district;

            address += (address ? "<br />" : "") + cityLine;
          }
          if (this.settings.displayLocationCountry && adr.address.country)
            address += (address ? "<br />" : "") + adr.country;
          if (adr.phone) {
            address += `<br><a
                   href="tel:${adr.phone}"
                    class="mr-3 mt-4 v-btn v-btn--contained v-btn--fab v-btn--round v-btn--router theme--light v-size--small">
                    <span class="v-btn__content">
                        <i class="mdi mdi-phone v-icon"></i>
                    </span>
                 </a>`;
          }
          if (adr.mobile) {
            address += `<a
                    href="tel:${adr.mobile}"
                    class="mr-3 mt-4 v-btn v-btn--contained v-btn--fab v-btn--round v-btn--router theme--light v-size--small">
                    <span class="v-btn__content">
                        <i class="mdi mdi-cellphone v-icon"></i>
                    </span>
                 </a>`;
          }
          if (adr.email) {
            address += `<a
                    href="mailto:${adr.email}"
                    target="_blank"
                    class="mr-3 mt-4 v-btn v-btn--contained v-btn--fab v-btn--round v-btn--router theme--light v-size--small">
                    <span class="v-btn__content">
                        <i class="mdi mdi-email v-icon"></i>
                    </span>
                 </a>`;
          }
          if (adr.website) {
            address += `<a
                    href="${this.validateWebsite(adr.website)}"
                    target="_blank"
                    class="mt-4 v-btn v-btn--contained v-btn--fab v-btn--round v-btn--router theme--light v-size--small">
                    <span class="v-btn__content">
                        <i class="mdi mdi-web v-icon"></i>
                    </span>
                 </a>`;
          }
        }
      }

      return address;
    },
    operatorTitle() {
      return (
        (this.event && this.event.operator && this.event.operator.title) || ""
      );
    },
    operatorAddress() {
      let address = "";

      if (this.event && this.event.operator) {
        if (this.event.operator_text) {
          address += `${this.event.operator_text} <br />`;
        }
        if (this.event.operator.address) {
          const adr = this.event.operator.address;

          if (adr.address) address += adr.address;
          if (adr.additional_address)
            address += (address ? "<br />" : "") + adr.additional_address;
          if (
            this.settings.displayLocationCity &&
            (adr.zip || adr.city || adr.district)
          ) {
            let cityLine = adr.zip ? adr.zip : "";
            if (adr.city) cityLine += (cityLine ? "  " : "") + adr.city;
            if (adr.district && this.settings.displayLocationDistrict)
              cityLine += (cityLine ? " – " : "") + adr.district;

            address += (address ? "<br />" : "") + cityLine;
          }
          if (this.settings.displayLocationCountry && adr.address.country)
            address += (address ? "<br />" : "") + adr.country;
        }
      } else if (this.event && this.event.operator_text)
        address = this.event.operator_text;

      return address;
    },
    operatorContact() {
      let address = "";

      if (this.event && this.event.operator) {
        if (this.event.operator.address) {
          const adr = this.event.operator.address;

          if (adr.phone) {
            address += `<a
                    href="tel:${adr.phone}"
                    class="v-btn mt-3 v-btn--contained v-btn--fab v-btn--round v-btn--router theme--light v-size--small">
                    <span class="v-btn__content">
                        <i class="mdi mdi-phone v-icon"></i>
                    </span>
                 </a>`;
          }
          if (adr.mobile) {
            address += `<a
                    href="tel:${adr.mobile}"
                    class="ml-3 mt-3 v-btn v-btn--contained v-btn--fab v-btn--round v-btn--router theme--light v-size--small">
                    <span class="v-btn__content">
                        <i class="mdi mdi-cellphone v-icon"></i>
                    </span>
                 </a>`;
          }
          if (adr.email) {
            address += `<a
                    href="mailto:${adr.email}"
                    target="_blank"
                    class="ml-3 mt-3 v-btn v-btn--contained v-btn--fab v-btn--round v-btn--router theme--light v-size--small">
                    <span class="v-btn__content">
                        <i class="mdi mdi-email v-icon"></i>
                    </span>
                 </a>`;
          }
          if (adr.website) {
            address += `<a
                    href="${this.validateWebsite(adr.website)}"
                    target="_blank"
                    class="ml-3 mt-3 v-btn v-btn--contained v-btn--fab v-btn--round v-btn--router theme--light v-size--small">
                    <span class="v-btn__content">
                        <i class="mdi mdi-web v-icon"></i>
                    </span>
                 </a>`;
          }
        }
      }

      return address;
    },
    routeAddress() {
      return this.event && this.event.location
        ? getGoogleRouteLinkForAddress(this.event.location.address)
        : undefined;
    },
    categories() {
      // collect renamed categories
      const categories = [];

      if (this.event) {
        if (
          this.event.category &&
          this.$store.state.labelsById[this.event.category]
        ) {
          categories.push(this.$store.state.labelsById[this.event.category]);
        }
        if (
          this.event.additional_categories &&
          this.event.additional_categories.length
        ) {
          this.event.additional_categories.forEach(category => {
            if (this.$store.state.labelsById[category]) {
              categories.push(this.$store.state.labelsById[category]);
            }
          });
        }
      }

      return categories.length ? categories : null;
    },
    today() {
      return getToday();
    },
    formattedCalendarValue() {
      const d = moment(this.calendarValue).locale(this.$i18n.locale);

      return d.format("MMMM YYYY");
    },
    myURL() {
      return encodeURIComponent(window.location.href);
    },
    linkTicketing() {
      return fixLink(this.event.link_ticketing);
    },
    listUri() {
      if (this.$store.state.listUri) {
        return (
          appendCurrentParamsToURL(this.$store.state.listUri) + "#eoev-list"
        );
      }
      return null;
    },
    calendarWidth() {
      if (this.widgetWidth >= 1900) return "35%";
      if (this.widgetWidth >= 1260) return "50%";
      if (this.widgetWidth >= 960) return "75%";

      return "100%";
    },
    firstPicture() {
      return this.webPictures.length && this.event.pictures[0];
    },
    locale() {
      return this.$i18n.locale;
    },
    cApiKey() {
      return this.apiKey || this.$store.state.apiKey;
    },
    mobilePhoneTooltipContent() {
      return `<a href="tel:${this.event.operator?.address?.phone}">${this.event.operator?.address?.phone}</a>`;
    },
    mobileCellphoneTooltipContent() {
      return `<a href="tel:${this.event.operator?.address?.mobile}">${this.event.operator?.address?.mobile}</a>`;
    },
    eMailTooltipContent() {
      return `<a href="mailto:${this.event.operator?.address?.email ||
        this.event.operator?.address?.contactEMail}">${this.event.operator
        ?.address?.email || this.event.operator?.address?.contactEMail}</a>`;
    }
  },
  methods: {
    fixLink,
    async loadData() {
      if (!this.eventId) {
        this.error = "data-event attribute missing!";
        return;
      }

      // define query
      const query = {
        populate: true, // fetch dependent data
        eventId: this.eventId,
        momentId: this.momentId
      };

      try {
        this.event = await findEvents(
          this.$store.state.apiUrl,
          this.cApiKey,
          query,
          false
        );
        if (this.event.error && this.event.error.message)
          this.error = this.event.error.message;
        if (this.event.channels?.includes("web")) {
          replaceWithWebContent(this.event);
          replaceWithWebContent(this.event.moment);
        }
      } catch (e) {
        this.error = e;
      }
    },
    getDiscountInformation() {
      if (this.event.price_from) {
        this.event.discount = this.event.discount.filter(
          item => item !== "withFee"
        );
      }
      if (!this.event.discount[0]) this.event.discount.shift();
      this.event.discount = this.event.discount.map(item => {
        switch (item) {
          case "free_access":
            return "Freier Eintritt";
          case "withFee":
            return "Mit Eintritt";
          case "guest_card":
            return "Frei mit Gästekarte";
          case "discountGuestCard":
            return "Rabatt mit Gästekarte";
        }
      });
    },

    linkBack() {
      if (this.listUri) {
        window.location.assign(this.listUri);
      } else {
        window.history.go(-1);
      }
    },

    async loadSettings() {
      try {
        const data = await findConfig(this.$store.state.apiUrl, this.cApiKey);
        if (data && data.apiKeys && data.apiKeys.length) {
          this.settings = data.apiKeys[0]; // find first API key setting since this will be ours
        }
      } catch (e) {
        this.error = e;
      }
    },
    readMoreToggler() {
      this.readMore = !this.readMore;
    },
    onResize() {
      this.widgetWidth = this.$refs.theWidget.offsetWidth;
    },
    validateWebsite(website) {
      if (
        website &&
        typeof website === "string" &&
        !website.startsWith("http")
      ) {
        return "http://" + website;
      } else {
        return website;
      }
    },
    async showCalendar() {
      if (this.firstClickOnCalendarPanel) {
        // load moments
        try {
          const moments = await findMomentsForEventId(
            this.$store.state.apiUrl,
            this.cApiKey,
            this.event._id
          );

          moments.forEach(mom => {
            const start = moment(mom.from);
            const end = moment(mom.to);
            const now = moment();

            if (now.isSameOrBefore(start)) {
              this.loadedMoments.push({
                name:
                  mom.short_title ||
                  mom.title ||
                  this.event.short_title ||
                  this.event.title ||
                  "???",
                start: start.format("YYYY-MM-DD HH:mm"),
                end: end.format("YYYY-MM-DD HH:mm"),
                startList: start.format("DD.MM.YYYY"),
                timeList: start.format("HH:mm"),
                moment: mom
              });
            }
          });
          // determine month of current event - or jump to first element
          let start;
          if (this.event.moment) {
            start = moment(this.event.moment.from);
          } else if (this.loadedMoments.length)
            start = moment(this.loadedMoments[0].moment.from);

          if (start) {
            start.subtract(start.utcOffset(), "m");

            this.calendarValue = start.format("YYYY-MM-DD");
          }
        } catch (e) {
          this.error = e;
        } finally {
          this.loadingMoments = false;
          this.firstClickOnCalendarPanel = false;
        }
      }
    },
    async moveToDates() {
      const index = this.$refs.panels.$children.indexOf(this.$refs.datesPanel);
      const datesHeader = document.querySelector("#datesHeader");
      await this.showCalendar();
      this.openPanel = index;
      setTimeout(() => {
        datesHeader.scrollIntoView();
      }, 420);
    },
    getSliceLength(longDescription) {
      const regex = /\./gi;
      const indices = [];
      let result;
      while ((result = regex.exec(longDescription))) {
        indices.push(result.index);
      }
      const index = indices.find(i => {
        return i > 400 && i < 600;
      });
      return index || 400;
    },

    showEvent($event) {
      // replace place holder strings with meaningful stuff
      const uri = appendCurrentParamsToURL(
        this.$store.state.targetUri
          .replace(/xxxSLUGxxx/, this.event.url_slug)
          .replace(/xxxMOMENTxxx/, $event.event.moment._id)
      );

      if (uri) {
        // try to push URL into state - see https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
        if (window.history) {
          // replace current moment
          this.event.moment = $event.event.moment;

          // set URI as state
          try {
            window.history.pushState(
              {
                event: this.event.url_slug,
                moment: $event.event.moment._id
              },
              "",
              uri
            );
            this.loadLdJson();
          } catch (e) {
            // force loading on failure (XSS or similar...)
            window.location.href = uri;
          }
        } else {
          // force loading
          window.location.href = uri;
        }
      }
    },
    onExportCalendarClick() {
      createICal(this.event);
    },
    onFavoritesClick() {
      const id =
        this.event._id + (this.event.moment ? ":" + this.event.moment._id : "");

      if (this.isFavorite) {
        this.$store.commit("removeFavorite", id);
      } else {
        this.$store.commit("addFavorite", id);
      }
    },
    toggleMobileMap() {
      this.mobileMap = !this.mobileMap;
      // widgetWidth größe ändern um karte zu refreshen (graue flächen verhindern)
      this.refreshMapValue += 0.01;
      // scroll up
      this.$vuetify.goTo(300);
    },
    async loadLdJson() {
      // load LD+JSON
      this.ldJson = await findLdJson(
        this.$store.state.apiUrl,
        this.cApiKey,
        this.$store.state.targetUri,
        this.event.url_slug,
        this.event.moment && this.event.moment._id
      );
    },
    humanFileSize,
    getFileTypeIcon,
    getArrivalDescription(event) {
      return event.moment?.arrival_description || event.arrival_description;
    },
    openTooltip(key) {
      const value = !this[key];
      this.closeAllTooltips();
      this[key] = value;
    },
    closeAllTooltips() {
      this.isCellphoneOpen = false;
      this.isEmailOpen = false;
      this.isPhoneOpen = false;
    }
  },
  i18n
};
